import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from "react";

// Interfaces
import { IPayrollMappingContext } from "./interfaces";

// Constants
import { PAYROLL_MAPPING_TABS } from "@/Settings/Constants/PayrollMapping";

const CRMContext = createContext<IPayrollMappingContext>({
	locationId: "",
	tabs: PAYROLL_MAPPING_TABS,
	tabSelected: 0,
	setTabSelected: () => {},
});

const usePayrollMappingsStore = (store: IPayrollMappingContext) => {
	return useMemo(() => store, [store]);
};

type TPayrollMappingsContextProviderProps = {
	children: ReactNode;
	locationId?: string;
};

const PayrollMappingsContextProvider = (props: Readonly<TPayrollMappingsContextProviderProps>) => {
	const { children = null, locationId = "" } = props ?? {};

	// States
	const [tabSelected, setTabSelected] = useState<number>(0);

	// Store build
	const store = usePayrollMappingsStore({
		locationId,
		tabSelected,
		setTabSelected,
		tabs: PAYROLL_MAPPING_TABS,
	});

	useEffect(() => {
		return () => {};
	}, [locationId]);

	return <CRMContext.Provider value={store}>{children}</CRMContext.Provider>;
};

function usePayrollMappingsContext() {
	const context = useContext(CRMContext);
	if (!context) {
		throw new Error("usePayrollMappingsContext must be used within a PayrollMappingsContextProvider");
	}
	return context;
}

export { PayrollMappingsContextProvider, usePayrollMappingsContext };
